module.exports = __webpack_public_path__ + "static/img/tips.d654ac99.png";